

export class CompanyRuleDetailsStatusInput implements ICompanyRuleDetailsStatusInput {
    /** The auto-generated id of the company rule details master */
    companyRuleDetailId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: ICompanyRuleDetailsStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyRuleDetailId = _data["companyRuleDetailId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CompanyRuleDetailsStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyRuleDetailsStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyRuleDetailId"] = this.companyRuleDetailId;
        data["status"] = this.status;
        return data; 
    }
}

export interface ICompanyRuleDetailsStatusInput {
    /** The auto-generated id of the company rule details master */
    companyRuleDetailId: number;
    /** The updated status */
    status: number;
}

